/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
import './device_code';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "external": {
            "nested": {
              "GetDeviceCodeRequest": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetDeviceCodeResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "deviceCode": {
                    "type": ".squareup.devicesettings.external.DeviceCode",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.GetDeviceCodeRequest && !$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.GetDeviceCodeResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetDeviceCodeRequest @ squareup/devicesettings/external/device_code_get.proto at 14:1
 */
export const GetDeviceCodeRequest = $root.lookupType('squareup.devicesettings.external.GetDeviceCodeRequest');
fixType(GetDeviceCodeRequest);
Builder.createAndAttachToType(GetDeviceCodeRequest);
/**
 * SOURCE GetDeviceCodeResponse @ squareup/devicesettings/external/device_code_get.proto at 24:1
 */
export const GetDeviceCodeResponse = $root.lookupType('squareup.devicesettings.external.GetDeviceCodeResponse');
fixType(GetDeviceCodeResponse);
Builder.createAndAttachToType(GetDeviceCodeResponse);